import { TranslocoService } from '@jsverse/transloco';

export function managerAtRiskReasonKey(reason?: string): string {
  switch (reason) {
    case 'UnpaidThisMonth':
      return 'Not paid this month';
    case 'ExpiringSoon':
      return 'Expiring soon';
    case 'UnpaidAndExpiringSoon':
      return 'Unpaid and expiring soon';
    case 'TrialEndingSoon':
      return 'Trial ending soon';
    default:
      return 'Expiring soon';
  }
}

export function formatManagerAtRiskNotification(
  transloco: TranslocoService,
  data: {
    name: string;
    riskReason?: string;
    daysUntilExpiry?: number;
  },
): string {
  const days = data.daysUntilExpiry;

  switch (data.riskReason) {
    case 'UnpaidAndExpiringSoon':
      return days != null
        ? transloco.translate('manager_at_risk_unpaid_expiring', {
            name: data.name,
            days,
          })
        : transloco.translate('manager_at_risk_unpaid', { name: data.name });
    case 'UnpaidThisMonth':
      return transloco.translate('manager_at_risk_unpaid', { name: data.name });
    case 'TrialEndingSoon':
      return days != null
        ? transloco.translate('manager_at_risk_trial_ending', {
            name: data.name,
            days,
          })
        : transloco.translate('manager_at_risk_trial_ending_soon', {
            name: data.name,
          });
    case 'ExpiringSoon':
    default:
      return days != null
        ? transloco.translate('manager_at_risk_expiring', {
            name: data.name,
            days,
          })
        : transloco.translate('manager_at_risk_expiring_soon', {
            name: data.name,
          });
  }
}
